export enum MapaTipo {
  GOOGLE_MAPS = 'GOOGLE_MAPS',
  MAPBOX = 'MAPBOX',
}
